export default __webpack_public_path__ + "static/nbc-2-2dcecabb365afada10f1b500620cb9e5.svg";